/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_PlayInputs */



/**
* | output |
* | --- |
* | "Play" |
*
* @param {Nav_Section_PlayInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_section_play = /** @type {((inputs?: Nav_Section_PlayInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_PlayInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spielen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Jouer")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("对战")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("遊玩")
	if (locale === "ko") return /** @type {LocalizedString} */ ("플레이")
	return /** @type {LocalizedString} */ ("Play")
});